// extracted by mini-css-extract-plugin
export default {"root":"EpisodeList_root__PC5rL","pagination":"EpisodeList_pagination__XWU0Q"};